import React from 'react';
import { toAbsoluteUrl } from 'assets/helpers/AssetHelpers';

const HeroVideo = () => {
	return (
		<video autoPlay muted loop playsInline preload="auto" className="hero-video">
			<source src={toAbsoluteUrl('/media/herosection/hero-video.mp4')} type="video/mp4" />
			Your browser does not support the video tag.
		</video>
	);
};

export default HeroVideo;
